import { AccountInfo } from "shared-domains/domains/account-management/individual/account.model";
import { AccountService } from "app/core/services/api/account-management/individual/account.service";
import { Subject, takeUntil } from "rxjs";

import { BooleanInput } from "@angular/cdk/coercion";
import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";
import { VlpIconComponent } from "shared-ui/components/vlp-icon/vlp-icon.component";

@Component({
    selector: "user",
    templateUrl: "./user.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: "user",
    standalone: true,
    imports: [CommonModule, VlpIconComponent, TranslocoModule],
})
export class UserComponent implements OnInit, OnDestroy {
    // -----------------------------------------------------------------------------------------------------
    // @ Inputs & fields — trạng thái menu người dùng
    // -----------------------------------------------------------------------------------------------------
    static ngAcceptInputType_showAvatar: BooleanInput;

    @Input() showAvatar = true;
    account: AccountInfo;
    open = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    // -----------------------------------------------------------------------------------------------------
    // @ Constructor
    // -----------------------------------------------------------------------------------------------------
    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _accountService: AccountService,
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        this._accountService.account$.pipe(takeUntil(this._unsubscribeAll)).subscribe((account: AccountInfo) => {
            if (account) {
                this.account = account;
            } else {
                this.account = new AccountInfo();
            }
            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods — event handlers / UI actions
    // -----------------------------------------------------------------------------------------------------

    toggle(event: MouseEvent): void {
        event.stopPropagation();
        this.open = !this.open;
    }

    @HostListener("document:click")
    closeMenu(): void {
        if (this.open) {
            this.open = false;
            this._changeDetectorRef.markForCheck();
        }
    }

    showProfile(): void {
        this._router.navigate(["/profile/update-profile"]);
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(["/sign-out"]);
    }
}
